import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const musicArtistAlbumpageApi = createApi({
  reducerPath: 'musicArtistAlbumpageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL + 'music' ,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('musicArtistAlbumpageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchMusicArtistAlbumData: builder.query({
      query: (option) => ({
        url : 'artist/album',
        method: 'POST',
        body : {
            "phone": "",
            "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id": getLocalStorageData(),
            "version_code": 20,
            "version_name": "1.2.9",
            "artist_id" : option.artist_id
        },
      }), 
    })
  }),
});

export const { useFetchMusicArtistAlbumDataQuery, endpoints } = musicArtistAlbumpageApi;